import { useAppDisplayModeContext } from '@archipro-design/aria';
import { useLoaderData } from '@remix-run/react';
import type { loader } from '~/routes/_app.project.$urlSegment._index';
import FeaturedProductsMobile from '@modules/project/component/featured-products/FeaturedProducts.mobile';
import FeaturedProfessionalsMobile from '@modules/project/component/featured-professionals/FeaturedProfessionals.mobile';
import FeaturedProjectsMobile from '@modules/project/component/featured-projects/FeaturedProjects.mobile';
import AboutProfessional from '@modules/project/component/about-professional/AboutProfessional';
import { DetailPageButtons } from '@modules/business-manager/component/detail-page-buttons/DetailPageButtons';
import FeaturedProducts from '@modules/project/component/featured-products/FeaturedProducts';
import FeaturedProfessionals from '@modules/project/component/featured-professionals/FeaturedProfessionals';
import FeaturedProjects from '@modules/project/component/featured-projects/FeaturedProjects';

const ProjectPageContent = () => {
    const { mobile } = useAppDisplayModeContext();
    const {
        project,
        featuredProducts,
        featuredProfessionals,
        featuredProjects,
        detailButton,
    } = useLoaderData<typeof loader>();

    return (
        <>
            {mobile ? (
                <>
                    {featuredProducts.FeaturedProducts?.edges.length ? (
                        <FeaturedProductsMobile data={featuredProducts} />
                    ) : null}
                    {featuredProfessionals.FeaturedProfessionals?.edges
                        .length ? (
                        <FeaturedProfessionalsMobile
                            data={featuredProfessionals}
                        />
                    ) : null}
                    {featuredProjects.FeaturedProjects?.edges.length ? (
                        <FeaturedProjectsMobile data={featuredProjects} />
                    ) : null}
                </>
            ) : (
                <>
                    {featuredProducts.FeaturedProducts?.edges.length ? (
                        <FeaturedProducts
                            parentID={project.ID}
                            data={featuredProducts}
                        />
                    ) : null}
                    {featuredProfessionals.FeaturedProfessionals?.edges
                        .length ? (
                        <FeaturedProfessionals data={featuredProfessionals} />
                    ) : null}
                    {featuredProjects.FeaturedProjects?.edges.length ? (
                        <FeaturedProjects data={featuredProjects} />
                    ) : null}
                    <AboutProfessional data={project} />
                    <DetailPageButtons {...detailButton} />
                </>
            )}
        </>
    );
};
export default ProjectPageContent;
